// extracted by mini-css-extract-plugin
export default {"gray100":"#e1e4e8","gray150":"#d6dade","gray1100":"#232c35","gray1150":"#1b242d"};